<script lang="ts">
  import { help } from "../stores";
  import Tip from "./Tip.svelte";
  const toggleControls = () => help.update((val) => !val);
</script>

<button on:click={toggleControls}>help (?) </button>

<div>
  <Tip>
    <h3>keyboard controls</h3>
    <ul>
      <li><kbd>&LongRightArrow;</kbd>next page</li>
      <li><kbd>&LongLeftArrow;</kbd>previous page</li>
      <li><kbd>?</kbd>display help</li>
    </ul>
  </Tip>
</div>

<style>
  button {
    margin: 0;
    cursor: pointer;
  }

  div {
    position: absolute;
    z-index: 2;
    top: 3rem;
    right: 1rem;
  }

  kbd {
    font-family: "Inconsolata", monospace;
    background-color: #eee;
    padding: 0 0.5rem;
    border-radius: 2px;
    border: 1px solid #999;
    border-width: 0 1px 1px 0;
    margin-right: 0.5rem;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  h3 {
    margin-bottom: 0.5rem;
  }
</style>
